import type { TealiumEventData } from 'src/types/trackingData';

const JOB_AD_PRESSED = 'job_ad_pressed';
export const viewJobAdLinkClicked: TealiumEventData = {
  linkName: JOB_AD_PRESSED,
  eventName: [JOB_AD_PRESSED],
};
